<template>
  <base-page
    :title="'Plans & Billing'"
  >
    <template #main>
      <!--      <account-billing-details />-->

      <v-row
        v-if="isLoading"
        align="center"
        justify="center"
        class="mt-10"
      >
        <v-progress-circular
          :size="125"
          :width="10"
          color="primary"
          indeterminate
        />
      </v-row>

      <account-subscription
        v-if="!isLoading"
        :customer="customer"
      />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import AccountBillingDetails from "../../components/Account/AccountBillingDetails"
import AccountSubscription from "../../components/Account/AccountSubscription"
import { mapActions, mapGetters } from "vuex"

export default {
  components: {
    AccountSubscription,
    AccountBillingDetails,
    BasePage,
  },
  computed: {
    ...mapGetters([ 'hasStripeAccount' ]),
  },
  data() {
    return {
      isLoading: true,
      customer: {}
    }
  },
  async mounted() {
    await this.fetchAccount()
  },
  methods: {
    ...mapActions([ 'getAccount', 'getCustomer']),
    async fetchAccount() {
      if (this.hasStripeAccount) {
        this.isLoading = true
        const account = await this.getAccount({})

        this.account = account || {}
        const { customer: customerId } = this.account.metadata || {}

        const payload = {
          id: customerId,
          _headers: {
            'x-account': ''
          }
        }
        const customer = await this.getCustomer(payload)
        this.customer = customer || {}
        this.isLoading = false
      }
    }
  }
}
</script>
